import React, { useEffect, useState } from "react";
import help_icon from "../images/sidebar_icon/help_icon.svg";
import InvestmentHeaderBox1 from "../components/InvestmentHeaderBox1";
import "../styles/redeem.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { redeemShow, redeemStore } from "../actions/holdingAction";
import { nachSendOtp, nachVerifyOtp } from "../actions/cardAction";
import { getLocalStorageUserData } from "../utils/userData";
import { currentDate } from "../utils/DateFormate";
import { useFormik } from "formik";
import * as Yup from "yup";
import PopupModel from "../components/PopupModel";
import successlogo from "../images/popup/success-popup.svg";
import cancel from "../images/popup/alert-image.svg";
// Functional component for the Home page
const Redeem = () => {
  const [isPopupVisible, setIsPopupVisible] = useState(false); // Manage popup visibility
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [otpMessage, setOtpMessage] = useState("");
  const [verifyOtpError, setVerifyOTPError] = useState("");
  const [viewBtn, setViewBtn] = useState(false);
  const [verifyBtnDisable, setVerifyBtnDisable] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = getLocalStorageUserData();
  const state = location.state;

  const holdingsData = useSelector((state) => state.holdings);
  const dataOfRedeem = location?.state?.props;

  const closeModal = () => {
    setIsPopupVisible(false);
  };

  const closeOtpModal = () => {
    setShowOtpModal(false);
    setIsOtpVerified(false);
    setOtp(["", "", "", "", "", ""]);
    setOtpMessage("");
    setVerifyOTPError("");
    setViewBtn(false);
    setIsDisabled(false);
  };

  const cancelBack = () => {
    formik.resetForm();
    navigate("/portfolio");
  };

  const handleOtpChange = (e, index) => {
    const value = e.target.value;

    if (/[^0-9]/.test(value) && value !== "") return;

    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);

    if (value && index < otp.length - 1) {
      const nextInput = document.getElementById(`otp-input-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
    if (!value && index > 0) {
      const prevInput = document.getElementById(`otp-input-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "") {
      if (index > 0) {
        const prevInput = document.getElementById(`otp-input-${index - 1}`);
        if (prevInput) prevInput.focus();
      }
    }
  };

  const sendOtp = () => {
    setIsDisabled(true);
    dispatch(nachSendOtp(userData?.id)).then((response) => {
      if (response?.status === true) {
        setViewBtn(true);
      }
    });
    setTimeout(() => {
      setIsDisabled(false);
    }, 120000); // 120000ms = 2 minutes
  };

  const verifyOtp = () => {
    setVerifyBtnDisable(true);
    if (otp.every((digit) => digit === "")) {
      setVerifyOTPError("OTP is required");
      setVerifyBtnDisable(false);
    } else if (otp.some((digit) => digit === "")) {
      setVerifyOTPError("OTP length must be 6 digits");
      setVerifyBtnDisable(false);
    } else {
      setVerifyOTPError("");
      const payload = {
        id: userData?.id,
        otp: otp.join(""),
      };
      dispatch(nachVerifyOtp(payload)).then((res) => {
        setVerifyBtnDisable(false);
        if (res?.status === false) {
          setOtpMessage(res?.message);
        } else {
          setIsOtpVerified(true);
          setViewBtn(false);
          setOtpMessage(res?.message);
        }
      });
    }
  };

  const handleRedeemConfirm = () => {
    dispatch(redeemStore(formik.values))
      .then((response) => {
        if (response) {
          if (response?.status === true) {
            closeOtpModal();
            navigate(
              `/orders?order=${
                response?.orderid ? response?.orderid : response?.data?.order
              }`
            );
          } else {
            closeOtpModal();
            setIsPopupVisible(true);
          }
        }
      })
      .catch((error) => {
        closeOtpModal();
        setIsPopupVisible(true);
      });
  };

  console.log("dataOfRedeem", dataOfRedeem);
  useEffect(() => {
    if (dataOfRedeem) {
      const payload = {
        product_id: dataOfRedeem?.product_id,
        folio_no: dataOfRedeem?.folioNumber,
      };
      dispatch(redeemShow(payload));
    }
  }, [dataOfRedeem]);

  const formik = useFormik({
    initialValues: {
      id: userData?.id || "",
      order_amount:
        holdingsData?.redeemShow?.data?.amt ||
        Number(
          (dataOfRedeem?.current_value || "0").replace(/,/g, "")
        ),
      redemption_units: holdingsData?.redeemShow?.data?.amt
        ? ""
        : holdingsData?.redeemShow?.data?.unit || dataOfRedeem?.units,
      amt_unit_type: holdingsData?.redeemShow?.data?.amt_unit_type || "Amount",
      full_redeem: holdingsData?.redeemShow?.data?.full_redeem || 0,
      client_code: holdingsData?.redeemShow?.data?.client_code,
      scheme_code: holdingsData?.redeemShow?.data?.product?.scheme_code,
      trxn_type: "R",
      buy_sell_type: "ADDITIONAL",
      demat_physical: "P",
      folio_no: holdingsData?.redeemShow?.data?.folio_no,
      kyc_flag: "Y",
      euin_declaration: "N",
      min_redemption_flag: "N",
      dpc_flag: "Y",
      all_units: "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      order_amount: Yup.string()
        .matches(/^\d+(\.\d+)?$/, "Amount must only contain numbers")
        .when(["amt_unit_type", "full_redeem"], (values, schema) => {
          const [amt_unit_type, full_redeem] = values;
          if (amt_unit_type === "Amount") {
            if (full_redeem == 0) {
              return schema.required("Amount is required");
            }
            return schema.notRequired();
          }
          return schema;
        }),
      redemption_units: Yup.string()
        .matches(/^\d+(\.\d+)?$/, "Units must only contain numbers")
        .when(["amt_unit_type", "full_redeem"], (values, schema) => {
          const [amt_unit_type, full_redeem] = values;
          if (amt_unit_type === "Units") {
            if (full_redeem == 0) {
              return schema.required("Units is required");
            }
            return schema.notRequired();
          }
          return schema;
        }),
    }),
    onSubmit: (values) => {
      setShowOtpModal(true);
      setIsDisabled(true);
      dispatch(nachSendOtp(userData?.id)).then((response) => {
        if (response?.status === true) {
          setViewBtn(true);
        }
      });
      setTimeout(() => {
        setIsDisabled(false);
      }, 120000);
    },
  });

  const actionPopup = () => {
    navigate("/portfolio");
  };

  return (
    <div className="container-fluid page_background ">
      <div className="page-inner-content mb-3">
        <div className="page_inner_content_box">
          <h5 className="mb-4 main-heading-title">
            <Link className="back_icon" to="/portfolio">
              <FontAwesomeIcon icon={faAngleLeft} className="color me-3" />
            </Link>
            Redeem
          </h5>
          <InvestmentHeaderBox1 props={dataOfRedeem} />
          <form onSubmit={formik.handleSubmit}>
            <div className="card redeam_bottom_card ">
              <div className="card-body p-0">
                <div className="row align-items-center r_inner_section">
                  <div className="col-md-auto col-sm-auto my-1">
                    <h6 className="text-muted r_inner_title mb-0">
                      Amount:
                      <span className="fw-bold ms-2">
                        ₹
                        {Number(
                          (dataOfRedeem?.current_value || "0").replace(
                            /,/g,
                            ""
                          )
                        )}
                      </span>
                    </h6>
                  </div>
                  <div className="col-md-auto col-sm-auto px-lg-3 px-0">
                    <span className="divider"></span>
                  </div>
                  <div className="col-md-auto col-sm-auto my-1">
                    <h6 className="text-muted r_inner_title mb-0">
                      Available units:
                      <span className="fw-bold ms-2 ">
                        {Number(dataOfRedeem?.units || 0)}
                      </span>
                    </h6>
                  </div>
                  <div className="col-md-auto col-sm-auto px-lg-3 px-0">
                    <span className="divider"></span>
                  </div>
                  <div className="col-md-auto col-sm-auto my-1">
                    <h6 className="text-muted r_inner_title mb-0">
                      NAV as on {currentDate()}:
                      <span className="fw-bold ms-2 text_success">
                        ₹
                        {Number(
                          holdingsData?.redeemShow?.data?.product_nav || 0
                        ).toFixed(2)}
                      </span>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            <div className="card redeam_bottom_card">
              <div className="row form_body justify-content-center">
                <div className="col-xl-7 col-lg-10 col-md-10 my-2">
                  {formik.values.amt_unit_type == "Amount" && (
                    <div className="row align-items-center mb-3">
                      <div className="col-lg-5 col-md-6 col-sm-5">
                        <label htmlFor="amount" className="form-label">
                          Amount to Redeem
                        </label>
                      </div>
                      <div className="col-lg-7 col-md-6 col-sm-7">
                        <input
                          type="text"
                          name="order_amount"
                          className="form-control"
                          id="Amount"
                          placeholder="₹"
                          disabled={formik.values.full_redeem} // Disable if full redeem is selected
                          value={formik.values.order_amount}
                          onChange={formik.handleChange}
                        />
                        {formik.errors.order_amount &&
                          formik.touched.order_amount && (
                            <div className="text-danger">
                              {formik.errors.order_amount}
                            </div>
                          )}
                      </div>
                    </div>
                  )}
                  {formik.values.amt_unit_type == "Units" &&
                    (formik.values.full_redeem == 0 ||
                      formik.values.full_redeem == 1) && (
                      <div className="row align-items-center mb-3">
                        <div className="col-lg-5 col-md-6 col-sm-5">
                          <label
                            htmlFor="redemption_units"
                            className="form-label"
                          >
                            Number of Units
                          </label>
                        </div>
                        <div className="col-lg-7 col-md-6 col-sm-7">
                          <input
                            type="text"
                            name="redemption_units"
                            className="form-control"
                            id="redemption_units"
                            placeholder="Units"
                            disabled={formik.values.full_redeem} // Disable if full redeem is selected
                            value={formik.values.redemption_units}
                            onChange={formik.handleChange}
                          />
                          {formik.errors.redemption_units &&
                            formik.touched.redemption_units && (
                              <div className="text-danger">
                                {formik.errors.redemption_units}
                              </div>
                            )}
                        </div>
                      </div>
                    )}
                  <div className="row align-items-center mb-3">
                    <div className="col-lg-5 col-md-6 col-sm-5">
                      <label className="form-label">Redeem By</label>
                    </div>
                    <div className="col-lg-7 col-md-6 col-sm-7">
                      <div className="d-flex align-items-center gap-2 flex-wrap">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="amt_unit_type"
                            id="Amount"
                            value="Amount"
                            disabled={formik.values.full_redeem} // Disable if full redeem is selected
                            checked={formik.values.amt_unit_type === "Amount"}
                            onChange={formik.handleChange}
                          />
                          <label
                            className="form-check-label ms-2"
                            htmlFor="Amount"
                          >
                            Amount
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="amt_unit_type"
                            id="Units"
                            value="Units"
                            disabled={formik.values.full_redeem} // Disable if full redeem is selected
                            checked={formik.values.amt_unit_type === "Units"}
                            onChange={() => {
                              formik.setFieldValue("amt_unit_type", "Units");
                              formik.setFieldValue(
                                "redemption_units",
                                Number(dataOfRedeem?.units)
                              );
                            }}
                          />
                          <label
                            className="form-check-label ms-2"
                            htmlFor="Units"
                          >
                            Units
                          </label>
                        </div>
                      </div>
                      {formik.errors.amt_unit_type &&
                        formik.touched.amt_unit_type && (
                          <div className="text-danger">
                            {formik.errors.amt_unit_type}
                          </div>
                        )}
                    </div>
                  </div>

                  <div className="row align-items-center mb-3">
                    <div className="col-lg-5 col-md-6 col-sm-5"></div>
                    <div className="col-lg-7 col-md-6 col-sm-7">
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="full_redeem"
                          id="Redeem"
                          value={formik.values.full_redeem}
                          checked={
                            formik.values.full_redeem == 0 ? false : true
                          }
                          onChange={(e) => {
                            formik.setFieldValue(
                              "full_redeem",
                              e.target.checked == true ? 1 : 0
                            );
                            formik.setFieldValue(
                              "order_amount",
                             Number(
          (dataOfRedeem?.current_value || "0").replace(/,/g, "")
        )
                            );


                            formik.setFieldValue("redemption_units", dataOfRedeem?.units)

                            console.log("holdingsData", dataOfRedeem)
                            // formik.setFieldValue("amt_unit_type", "Amount");
                          }}
                        />
                        <label
                          className="form-check-label ms-2"
                          htmlFor="Redeem"
                        >
                          Full Redeem
                        </label>
                      </div>
                    </div>
                  </div>

                  {/* <button type="submit" className="btn btn-primary">
                    Submit
                  </button> */}
                </div>
              </div>
            </div>
            <div className="card-footer form_card form_card_border">
              <div className="d-flex justify-content-between gap-2">
                <button
                  type="button"
                  onClick={cancelBack}
                  className="form_button "
                >
                  Cancel
                </button>
                {console.log("ccxcxc",  formik.values.amt_unit_type === "Units"
                      ? parseFloat(dataOfRedeem?.units) <
                        parseFloat(formik.values.redemption_units)
                        ? true
                        : false
                      : parseFloat(Number(
          (dataOfRedeem?.current_value || "0").replace(/,/g, "")
        )) <
                        parseFloat(formik.values.order_amount)
                      ? true
                      : false, dataOfRedeem?.units ,formik.values.redemption_units ,parseFloat(Number(
          (dataOfRedeem?.current_value || "0").replace(/,/g, "")
        )), formik.values.order_amount  )}
                <button
                  type="submit"
                  disabled={
                    formik.values.amt_unit_type === "Units"
                      ? parseFloat(dataOfRedeem?.units) <
                        parseFloat(formik.values.redemption_units)
                        ? true
                        : false
                      : parseFloat(parseFloat(Number(
          (dataOfRedeem?.current_value || "0").replace(/,/g, "")
        ))) <
                        parseFloat(formik.values.order_amount)
                      ? true
                      : false
                  }
                  className="form_button next_btn"
                >
                  Redeem
                </button>
              </div>
            </div>
          </form>
          {showOtpModal && (
            <div
              className="modal fade modal_card_inner show"
              id="otpModal"
              tabIndex="-1"
              aria-labelledby="otpModalLabel"
              aria-hidden="false"
              style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
            >
              <div className="modal-dialog modal-dialog-centered p-3">
                <div className="modal-content">
                  {/* Modal Header */}
                  <div className="modal-header">
                    <h5 className="modal-title" id="otpModalLabel">
                      OTP Verification
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={closeOtpModal}
                      aria-label="Close"
                    ></button>
                  </div>

                  {/* Modal Body */}
                  <div className="modal_body text-center">
                    {!isOtpVerified ? (
                      <div>
                        <label className="form_label">
                          Verify through OTP *
                          <a
                            onClick={() => {
                              if (!isDisabled) {
                                sendOtp();
                              }
                            }}
                            className={`ms-md-4 ms-3 underline cursor-pointer ${
                              isDisabled ? "text-muted" : "text-primary"
                            }`}
                          >
                            {isDisabled ? "Resend OTP (Wait 2 mins)" : "Send OTP"}
                          </a>
                        </label>

                        <div className="d-flex justify-content-center mt-md-4 mt-2">
                          {otp.map((value, index) => (
                            <input
                              key={index}
                              type="text"
                              maxLength="1"
                              className="otp-input text-center mx-1"
                              value={value}
                              onChange={(e) => handleOtpChange(e, index)}
                              onKeyDown={(e) => handleKeyDown(e, index)}
                              id={`otp-input-${index}`}
                              autoFocus={index === 0}
                            />
                          ))}
                        </div>
                        {verifyOtpError && (
                          <p style={{ color: "red", marginTop: "10px" }}>{verifyOtpError}</p>
                        )}
                        {otpMessage && (
                          <p style={{ color: "red", marginTop: "10px" }}>{otpMessage}</p>
                        )}
                        <div className="d-flex justify-content-center mt-3">
                          {viewBtn && (
                            <button
                              type="button"
                              className="verify_button"
                              disabled={verifyBtnDisable}
                              onClick={verifyOtp}
                            >
                              Verify OTP
                            </button>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex justify-content-center p-lg-2">
                        <button type="button" className="verified_button">
                          OTP verified!
                        </button>
                      </div>
                    )}
                  </div>

                  {/* Modal Footer */}
                  <div className="modal-footer form_card">
                    <div className="d-flex justify-content-between gap-3 w-100">
                      <button
                        type="button"
                        onClick={closeOtpModal}
                        className="form_button"
                      >
                        Close
                      </button>
                      <button
                        type="button"
                        disabled={!isOtpVerified}
                        onClick={handleRedeemConfirm}
                        className="form_button next_btn"
                      >
                        Proceed
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {isPopupVisible && holdingsData?.redeemStore?.status != true && (
            <PopupModel
              id="alertModel"
              title="Lorem Ipsum"
              content={holdingsData?.redeemStore?.message}
              image={cancel}
              actionPopup={actionPopup}
              closeModal={closeModal}
              btnColor={"btn-success"}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Redeem;
